import { supabase } from '../supabase';

const TABLE_NAME = 'admin_page_content';

export async function getPageOverride(pageKey, language) {
  const { data, error } = await supabase
    .from(TABLE_NAME)
    .select('content')
    .eq('page_key', pageKey)
    .eq('language', language)
    .maybeSingle();

  if (error) {
    throw error;
  }

  return data?.content || null;
}

export async function upsertPageOverride(pageKey, language, content) {
  const payload = {
    page_key: pageKey,
    language,
    content,
    updated_at: new Date().toISOString()
  };

  const { error } = await supabase.from(TABLE_NAME).upsert(payload, {
    onConflict: 'page_key,language'
  });

  if (error) {
    throw error;
  }
}

export async function deletePageOverride(pageKey, language) {
  const { error } = await supabase
    .from(TABLE_NAME)
    .delete()
    .eq('page_key', pageKey)
    .eq('language', language);

  if (error) {
    throw error;
  }
}
